/* =========================================================

========================================================= */

// import { createApp } from 'vue';
// import App from './App.vue';
// import Axios from "axios";
// import  '@/styles/custom.css';
// import { registerPlugins } from '@/plugins';
// import Vue3Toastify from 'vue3-toastify';
// import  store from '@/store/index';
// import 'vuetify/styles'; // Vuetify styles
// import '@mdi/font/css/materialdesignicons.css';
// import 'vue3-toastify/dist/index.css';
// import { Ckeditor } from '@ckeditor/ckeditor5-vue';
// import VueApexCharts from "vue3-apexcharts";
// import { formatDateView, formatDateDash, date_format, getCompanyInfo, number_format } from '@/plugins/helpers';
// import convertNumberToWords from "@/plugins/numberToWord";
//
// const app = createApp(App)
//
// app.use(Ckeditor);
// app.use(VueApexCharts);
//
// registerPlugins(app);
// app.use(store)
//
// app.use(
//   Vue3Toastify,
//   {
//     autoClose: 3000,
//     // multiple: false,
//     style: {
//       opacity: '0.9',
//       userSelect: 'initial',
//     },
//     transition: 'slide',
//     position:'top-right'
//   }
// );
//
// // Global helper functions
// app.config.globalProperties.$formatDateView = formatDateView
// app.config.globalProperties.$formatDateDash = formatDateDash
// app.config.globalProperties.$date_format = date_format
// app.config.globalProperties.$getCompanyInfo = getCompanyInfo
// app.config.globalProperties.$number_format = number_format
// app.config.globalProperties.$convertNumberToWords = convertNumberToWords
//
// app.mount('#app')
//
// Axios.interceptors.request.use(
//   config => {
//     let token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = "Bearer " + token;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );
//
// Axios.interceptors.response.use(
//   response => {
//     return response;
//   },
//   error => {
//     if (error.response.status == "401") {
//       localStorage.clear();
//       location.reload();
//     }
//     return Promise.reject(error);
//   }
// );

/* =========================================================
   1. IMPORTS
========================================================= */

import { createApp } from 'vue';
import App from './App.vue';
import Axios from 'axios';

import '@/styles/custom.css';
import { registerPlugins } from '@/plugins';

import Vue3Toastify from 'vue3-toastify';
import store from '@/store/index';

import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import 'vue3-toastify/dist/index.css';

import { Ckeditor } from '@ckeditor/ckeditor5-vue';
import VueApexCharts from 'vue3-apexcharts';

import {
    formatDateView,
    formatDateDash,
    date_format,
    getCompanyInfo,
    number_format
} from '@/plugins/helpers';

import convertNumberToWords from "@/plugins/numberToWord";


/* =========================================================
   2. CREATE VUE APPLICATION
========================================================= */

const app = createApp(App);


/* =========================================================
   3. REGISTER VUE PLUGINS
========================================================= */

app.use(Ckeditor);
app.use(VueApexCharts);

registerPlugins(app);
app.use(store);

app.use(Vue3Toastify, {
    autoClose: 3000,
    // multiple: false,
    style: {
        opacity: '0.9',
        userSelect: 'initial',
    },
    transition: 'slide',
    position: 'top-right'
});


/* =========================================================
   4. GLOBAL HELPER FUNCTIONS
========================================================= */

app.config.globalProperties.$formatDateView = formatDateView;
app.config.globalProperties.$formatDateDash = formatDateDash;
app.config.globalProperties.$date_format = date_format;
app.config.globalProperties.$getCompanyInfo = getCompanyInfo;
app.config.globalProperties.$number_format = number_format;
app.config.globalProperties.$convertNumberToWords = convertNumberToWords;


/* =========================================================
   5. GLOBAL API REQUEST CANCELLATION MANAGER
========================================================= */

// Stores all pending API requests
const pendingRequests = new Map();

let requestCounter = 0;

// Requests that should NOT be automatically cancelled
const protectedRequests = [
    // These lists are loaded by layoutAdmin and are shared across routes.
    "administration/get-company-list",
    "administration/get-branch-list",
    "administration/notifications",
    "administration/pusher-credentials",
];

// Cancel all registered pending requests
const cancelPendingRequests = () => {

    pendingRequests.forEach((controller, requestId) => {
        controller.abort();
    });

    pendingRequests.clear();

    console.log('[API] Pending requests cancelled');
};


/* =========================================================
   6. AXIOS REQUEST INTERCEPTOR
========================================================= */

Axios.interceptors.request.use(
    config => {

        // Attach authentication token
        const token = localStorage.getItem("token");

        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }

        // Register request for cancellation
        // Supports GET, POST, PUT, PATCH, DELETE
        // Only requests explicitly marked as protected are excluded

        const isProtected = protectedRequests.some(url =>
            config.url?.includes(url)
        );

        if (!isProtected && !config.signal) {

            const controller = new AbortController();
            const requestId = ++requestCounter;

            config.signal = controller.signal;
            config._requestId = requestId;

            pendingRequests.set(requestId, controller);
        }

        return config;
    },

    error => {
        return Promise.reject(error);
    }
);


/* =========================================================
   7. AXIOS RESPONSE INTERCEPTOR
========================================================= */

Axios.interceptors.response.use(

    response => {

        // Remove completed request from manager
        if (response.config?._requestId) {
            pendingRequests.delete(response.config._requestId);
        }

        return response;
    },

    error => {

        // Remove failed or cancelled request
        if (error.config?._requestId) {
            pendingRequests.delete(error.config._requestId);
        }

        // Ignore intentional request cancellation
        if (
            Axios.isCancel(error) ||
            error.code === 'ERR_CANCELED'
        ) {
            return Promise.reject(error);
        }

        // Handle unauthorized requests
        if (error.response?.status === 401) {
            localStorage.clear();
            location.reload();
        }

        return Promise.reject(error);
    }
);


/* =========================================================
   8. ROUTER NAVIGATION - AUTOMATIC API CANCELLATION
========================================================= */

// Get the registered Vue Router instance
const router = app.config.globalProperties.$router;

if (router) {

    router.beforeEach((to, from) => {

        // Cancel pending requests when leaving the current route
        if (from.fullPath !== to.fullPath) {
            cancelPendingRequests();
        }

    });

}


/* =========================================================
   9. MOUNT VUE APPLICATION
========================================================= */

app.mount('#app');
